// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2fLlG","header":"MessagesList_header__2ePMe","chat":"MessagesList_chat__3sBCS"};